import React, { useEffect, useState } from 'react';
import NewsroomInside from './NewsroomInside';

export default function InsideList({ postId }) {
  const [items, setItems] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(3);
  
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadMore();
  }, []);

  const loadMore = () => {
    if (loading || !hasMore) return;
    setLoading(true);
    
    $.ajax({
      url: `/newsroom/cureusu/${postId}?offset=${offset}&limit=${limit}`,
      method: 'GET',
      dataType: 'json',
      success: (data) => {
        setItems(prev => [...prev, ...data.items]);
        setOffset(data.nextOffset + limit);
        setHasMore(data.items.length === limit);
      },
      error: () => {
        setHasMore(false);
      },
      complete: () => {
        setLoading(false);
      }
    });
  };

  return (
    <div className="inside-newsroom-react">
      {items.map((item, idx) => (
        <NewsroomInside 
          key={idx}
          title={item.title}
          articles={item.articles}
        />
      ))}

      {hasMore && (
        <div className="row centered">
          <button
            className={`button primary large view-more ${loading ? 'disabled' : ''}`}
            onClick={loadMore}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'View More'}
          </button>
        </div>
      )}
    </div>
  );
}


